<template>
  <div>
    <a-modal
      title="修改密码"
      :visible="visible"
      @ok="changePasswordOk"
      :confirmLoading="confirmLoading"
      :keyboard="false"
      :closable="scene == 2"
      :maskClosable="scene == 2"
      @cancel="modalCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="modalCancel" v-if="scene == 2"
          >取消</a-button
        >
        <a-button
          key="submit"
          type="primary"
          :loading="confirmLoading"
          @click="changePasswordOk"
        >
          确定
        </a-button>
      </template>
      <a-form :form="form">
        <a-form-item v-bind="formItemLayout" label="旧密码" v-if="scene == 2">
          <a-input
            :maxLength='50'
            v-decorator="[
              'old_password',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入旧密码!'
                  },
                  {
                    validator: validateToNextPassword
                  }
                ]
              }
            ]"
            type="password"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="新密码">
          <a-input
            :maxLength='50'
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入密码'
                  },
                  {
                    pattern:  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,50}$/,
                    message: '密码必须由大小写字母+数字组成并且8位及以上'
                  },
                  // {
                  //   pattern: /\d+/g,
                  //   message: '必须包含大小写字母和数字'
                  // },
                  // {
                  //   pattern: /[a-z]+/gi,
                  //   message: '必须包含大小写字母和数字'
                  // },
                  {
                    validator: validateToNextPassword
                  }
                ]
              }
            ]"
            type="password"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="确认新密码">
          <a-input
            :maxLength='50'
            v-decorator="[
              'confirm_password',
              {
                rules: [
                  {
                    required: true,
                    message: '请确认新密码'
                  },
                  {
                    validator: compareToFirstPassword
                  }
                ]
              }
            ]"
            type="password"
            @blur="handleConfirmBlur"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { resetPwd } from '@/api/account'
import { loginOut } from '@/api/login'
export default {
  name: 'ChangePasswordModal',
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  props: {
    scene: {
      type: String,
      default: '2'
    }
  },
  data: () => ({
    visible: false,
    confirmLoading: false,
    formItemLayout: {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    },
    accountId: ''
  }),
  methods: {
    modalOpen(accountId) {
      this.accountId = accountId
      this.visible = true
    },
    modalCancel() {
      this.form.resetFields()
      this.visible = false
    },
    changePasswordOk() {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          values.scene = this.scene
          values.account_id = this.accountId
          resetPwd(values).then((res) => {
            if (0 === res.status) {
              this.$message.success(res.msg)
              this.visible = false
              this.form.resetFields()
              // 修改成功登出
              loginOut().then((res) => {
                if (0 === res.status) {
                  this.$router.replace({ name: 'login' })
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback('两次密码不一致')
      } else {
        callback()
      }
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    }
  }
}
</script>

<style scoped></style>
